/* eslint-disable react/jsx-no-useless-fragment */
import { CTAButton } from '@components/CTAButton';
import { BurgerMenu, CompanyLogo } from '@components/svgs';
import useScrollPosition from '@hooks/useScrollPosition';
import useWindowSize from '@hooks/useWindowSize';
import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { memo, useState } from 'react';
import { INavBarProps } from './Navbar.types';
import MobileNavBar from './components/MobileNavBar/MobileNavBar';
import styles from './styles.module.scss';

export const Navbar = memo<INavBarProps>(({ routes }) => {
  const scrollPosition = useScrollPosition();
  const { isDesktop, width } = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const onHandleOpenClick = () => {
    setIsMounted((prev) => !prev);
    if (!isOpen) setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const onHandleCloseClick = () => {
    setIsMounted((prev) => !prev);
    if (!isOpen) setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  const { pathname } = useRouter();

  const isPageScrolled =
    scrollPosition > 0 || pathname === '/schedule-a-demo' || pathname === '/features';

  if (typeof width === 'undefined') {
    return null;
  }

  return (
    <>
      <header className={classNames(styles.navBarContainer)}>
        {/* Apply white background and glass effect if user starts scrolling */}
        <div
          className={classNames(styles.navBarMobileContainer, {
            [styles.navBarContainerScrolled]: isPageScrolled,
          })}
        />
        <div className={styles.navBarContainerInner}>
          <div className={styles.routingLinksContainer}>
            <Link href="/" title="Perksbar">
              <CompanyLogo className={styles.logo} />
            </Link>
            {/* Desktop view navigation links */}
            {isDesktop &&
              routes.map(({ label, path }) => (
                <Link key={path} href={path}>
                  {label}
                </Link>
              ))}
          </div>
          {/* Desktop view buttons */}
          <div className={styles.ctaButtonsContainer}>
            <CTAButton variant="outlined" className={styles.clearButton}>
              <Link prefetch={false} href="/schedule-a-demo">
                Schedule a demo
              </Link>
            </CTAButton>
            <CTAButton variant="contained" className={styles.button}>
              <Link prefetch={false} href="/get-started">
                Login / Sign up
              </Link>
            </CTAButton>
          </div>
          {/* Mobile view hamburger menu */}
          <>
            <BurgerMenu className={styles.burgerMenu} onClick={onHandleOpenClick} />
            {isOpen && (
              <MobileNavBar
                routes={routes}
                onHandleCloseClick={onHandleCloseClick}
                isMounted={isMounted}
              />
            )}
          </>
        </div>
      </header>
    </>
  );
});

Navbar.displayName = 'Navbar';

export default Navbar;
